"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@services/quill/quill-clipboard-matchers");
require("@services/quill/quill-keyboard-bindings");
var angular_1 = require("angular");
/**
 * Class to handle the creation of new quill editors
 */
var QuillEditorFactory = /** @class */ (function () {
    function QuillEditorFactory(window, clipboardMatchers, keyboardBindings) {
        this.window = window;
        this.clipboardMatchers = clipboardMatchers;
        this.keyboardBindings = keyboardBindings;
    }
    QuillEditorFactory.prototype.create = function (selector, clipboardMatcherOptions, quillOptions) {
        var _this = this;
        if (quillOptions === void 0) { quillOptions = {}; }
        var quill = new this.window.Quill(selector, __assign(__assign({}, quillOptions), { modules: __assign(__assign({}, quillOptions.modules), { clipboard: {
                    matchers: this.clipboardMatchers.getMatchers(clipboardMatcherOptions)
                }, keyboard: {
                    bindings: {
                        handleEnter: {
                            key: 'Enter',
                            handler: function (range, context) {
                                _this.keyboardBindings.handleEnter(quill, range, context);
                            }
                        }
                    }
                } }) }));
        return quill;
    };
    QuillEditorFactory.$inject = [
        '$window',
        'pr.quillClipboardMatchers',
        'pr.quillKeyboardBindings'
    ];
    return QuillEditorFactory;
}());
exports.default = QuillEditorFactory;
(function (angularModule) {
    angularModule.service('pr.quillEditorFactory', QuillEditorFactory);
})(angular_1.module('qualtrics.pr'));
